import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { Stack, Divider } from '@mui/material';

function Copyright() {
  return (
    <Typography variant="body2" sx={styles.textStyle}>
      {'© '}
      {new Date().getFullYear()}
      <Link
        color="inherit"
        href="https://www.childrenshospital.org/"
        target="_blank"
        rel="noopener noreferrer">
        &nbsp;Boston Childrens&apos; Hospital
      </Link>
    </Typography>
  );
}

export default function Footer() {
  return (
    <Grid item xs={12} sm={12} md={12}>
      <CssBaseline />
      <Box component="footer" sx={styles.footerStyle}>
        <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
          <Typography variant="body2" sx={styles.textStyle}>
            Visit 300 Longwood Ave, Boston, MA 02115
          </Typography>
          <Typography variant="body2" sx={styles.textStyle}>
            <Link href="tel: 18443542160" target="_blank" rel="noopener noreferrer">
              Call +1-844-354-2160
            </Link>
          </Typography>
          <Typography variant="body2" sx={styles.textStyle}>
            <Link
              color="inherit"
              href="https://www.childrenshospital.org/legal/terms-use"
              target="_blank"
              rel="noopener noreferrer">
              Terms of Use
            </Link>
          </Typography>
          <Copyright />
        </Stack>
      </Box>
    </Grid>
  );
}

const styles = {
  footerStyle: {
    backgroundColor: '#EDF3FC',
    height: 66,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    mt: 'auto'
  },
  textStyle: {
    color: '#003087'
  }
};
